import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '../../../shared/services/base.service';
import { ApiResponse } from '../../../shared/model/api-response';
import { GameSession } from '../../../shared/model/game-session';

@Injectable({
  providedIn: 'root'
})
export class GameSessionService extends BaseService {

  private httpClient: HttpClient = inject(HttpClient);

  public getSessionsByTable(gameTableId: number): Observable<ApiResponse<Array<GameSession>>> {
    return this.httpClient.get<ApiResponse<Array<GameSession>>>(`${this.baseUrl}/game-sessions/game-table/${gameTableId}`);
  }

  public createSession(session: Partial<GameSession>, override: boolean = false): Observable<ApiResponse<GameSession>> {
    const params = new HttpParams().set('override', String(override));
    return this.httpClient.post<ApiResponse<GameSession>>(`${this.baseUrl}/game-sessions`, session, { params });
  }

  public checkIn(sessionId: number): Observable<ApiResponse<string>> {
    return this.httpClient.post<ApiResponse<string>>(`${this.baseUrl}/game-sessions/${sessionId}/check-in`, {});
  }

  public checkOut(sessionId: number): Observable<ApiResponse<string>> {
    return this.httpClient.post<ApiResponse<string>>(`${this.baseUrl}/game-sessions/${sessionId}/check-out`, {});
  }

  public getAllSessions(): Observable<ApiResponse<Array<GameSession>>> {
    return this.httpClient.get<ApiResponse<Array<GameSession>>>(`${this.baseUrl}/game-sessions`);
  }

  public updateSession(session: Partial<GameSession>, override: boolean = false): Observable<ApiResponse<GameSession>> {
    const params = new HttpParams().set('override', String(override));
    return this.httpClient.put<ApiResponse<GameSession>>(`${this.baseUrl}/game-sessions/update`, session, { params });
  }

  public deleteSession(sessionId: number, override: boolean = false): Observable<ApiResponse<string>> {
    const params = new HttpParams().set('override', String(override));
    return this.httpClient.delete<ApiResponse<string>>(`${this.baseUrl}/game-sessions/${sessionId}`, { params });
  }

  public getSessionById(sessionId: number): Observable<ApiResponse<GameSession>> {
    return this.httpClient.get<ApiResponse<GameSession>>(`${this.baseUrl}/game-sessions/${sessionId}`);
  }
}
